module.exports = __webpack_public_path__ + "img/new.f726406d.svg";